import actions from '@/core/store/aditivo-apostila/actions'
import state from '@/core/store/aditivo-apostila/state'

export default {
	actions,
	state,
}
